<div
  data-qa="kpi-cross-company-main"
  class="main h-[77vh] flex-grow flex flex-col items-center gap-[0.5rem]"
>
  <div
    *ngIf="!isLoading && !crossCompanyData.metrics.length"
    class="flex flex-col items-center w-full h-full justify-center gap-1p25"
    data-qa="kpi-cross-company-empty-state">
    <app-all-icons
      [iconNameAndStyling]="'empty-tray.svg; icon-size-3p125; black-9'"
    />
    <span class="title-3 bold600 black-12">
          @if (crossCompanyData.isEmptyDataProvided) {
            Selected companies and metrics have empty data
          } @else {
            No metrics or companies selected yet
          }
      </span>
    @if (isAdmin) {
      <app-button
        [attr.data-qa]="'kpi-cross-company-settings'"
        [additionalClasses]="'w-[7.96875rem]'"
        [type]="'accent'"
        [size]="'medium'"
        [showIcon]="'left'"
        [iconName]="'settings.svg'"
        (buttonClick)="showCrudModal = true"
      >
        Settings
      </app-button>
    }
  </div>
  <ng-container *ngIf="!isLoading && crossCompanyData.metrics.length">
    <div
      class="flex flex-row items-center justify-end w-full"
      data-qa="cross-company-settings-row"
    >
      @if (isAdmin) {
        <app-button
          class="cross-company-settings-button"
          [attr.data-qa]="'kpi-cross-company-settings'"
          [additionalClasses]="'width-6'"
          [type]="'accent'"
          [size]="'xsmall'"
          [showIcon]="'left'"
          [iconName]="'settings.svg'"
          (buttonClick)="showCrudModal = true">
          Settings
        </app-button>
      }
    </div>
    <div
      data-qa="cross-company-table"
      class="w-full h-full table-fms height-unset"
    >
      <table>
        <thead>
        <tr class="sticky-group">
          <th class="col-three-dots">
            <app-three-dots-menu
              data-qa="three-dots-menu"
              [matMenuTriggerFor]="menu"/>
            <mat-menu #menu="matMenu">
              <ul class="list">
                <app-drop-down-item
                  data-qa="export-to-excel-cross-company"
                  class="width-100pcnt"
                  [text]="'Export table'"
                  [iconNameAndStyling]="'excel.svg'"
                  (click)="exportTable()"/>
              </ul>
            </mat-menu>
          </th>
          <th class="col-metric">
            Metric
          </th>
          <th class="blank-space no-hover sticky-position"></th>
          @for (period of crossCompanyData.periods; track period) {
            <th class="col-period">
              <div
                [attr.data-qa]="'header-date-' + period"
                class="flex flex-col"
                [appScrollIntoView]="$last"
              >
                <span [attr.data-qa]="'header-month-' + period">{{ period | date: 'MMM,' }}</span>
                <span [attr.data-qa]="'header-year-' + period">{{ period | date:'yyyy' }}</span>
              </div>
            </th>
          }
          <th></th>
        </tr>
        </thead>
        <tbody>
          @for (metric of crossCompanyData.metrics; track metric) {
            <tr class="sticky-group">
              <td class="col-three-dots">
                <div class=" flex flex-row items-center justify-center w-full h-full"
                     [ngClass]="metric.role === MetricDataRole.ACTUAL ? 'shadow-actual' : 'shadow-budget'"
                >
                  <app-all-icons
                    class="clickable"
                    [attr.data-qa]="'metric-collapse-button-' + metric.groupName + '-' + metric.name"
                    [iconNameAndStyling]="(this.metric.showCompanies ? 'collapse' : 'expand') + '.svg;black-12;icon-size-1p25' "
                    (click)="flipMetricVisibility(metric)"/>
                </div>
              </td>
              <td class="col-metric">
                <div class="flex flex-row justify-between items-center">
                  <span
                    [attr.data-qa]="'metric-header-' + metric.groupName + '-' + metric.name"
                    class="bold600">
                    {{ metric.groupName }}: {{ metric.name }}
                  </span>
                  <app-all-icons
                    *ngIf="metric.dataProps.dataType === MetricDataType.NUMBER || metric.dataProps.dataType === MetricDataType.PERCENT"
                    class="clickable hover-main-8 black-7"
                    [attr.data-qa]="'cross-company-show-chart-button-' + metric.groupName + '-' + metric.name"
                    [iconNameAndStyling]="'chart.svg'"
                    (click)="openChartModal(metric)">
                  </app-all-icons>
                </div>
              </td>
              <td class="blank-space no-hover sticky-position"></td>
              <td *ngFor="let i of crossCompanyData.periods"></td>
              <td></td>
            </tr>
            @if (metric.showCompanies) {
              @for (company of metric.companies; track company.companyUUID) {
                <tr *ngIf="company.data.length" class="sticky-group">
                  <td class="col-three-dots"></td>
                  <td class="col-metric">
                    <div
                      [attr.data-qa]="'metric-company-name' + metric.groupName  + '-' + metric.name  + '-' + company.companyName"
                      class="pl-0.625 bold500 company-name light-bold"
                      (click)="goToCompanyMetrics(company)"
                    >{{ company.companyName }}
                    </div>
                  </td>
                  <td class="blank-space no-hover sticky-position"></td>
                  @for (data of company.data; track data.period) {
                    <td class="col-period"
                        *ngVar="Metric.deserializeMetric(metric) as deserializedMetric">
                      <div
                        *ngIf="data.rowValue && data.rowValue !== '0.0' && data.rowValue !== '0'"
                        [attr.data-qa]="'metric-raw-value' + metric.name  + '-' + metric.groupName  + '-' + company.companyName  + '-' + data.period"
                        class="start-row-container h-full relative"
                      >
                        @switch (metric.dataProps.dataType) {
                          @case (MetricDataType.NUMBER) {
                            <span>{{ (deserializedMetric.isNegative() ? -1 : 1) * Number(data.rowValue) | number:'1.0-0' | negativeValueToBraces }}</span>
                          }
                          @case (MetricDataType.PERCENT) {
                            <span>{{ (deserializedMetric.isNegative() ? -1 : 1) * Number(data.rowValue) | number:'1.2-2' | negativeValueToBraces }}
                              %</span>
                          }
                          @case (MetricDataType.DATE) {
                            <span>{{ data.rowValue }}</span>
                          }
                          @case (MetricDataType.STRING) {
                            <div class="space-between-horizontal-centered width-100pcnt show-on-hover-container">
                              <span>{{ data.rowValue | linkShort: 40 }}</span>
                              <app-all-icons
                                class="show-on-hover-object"
                                [attr.data-qa]="'metric-with-text-tooltip-' + metric.name + '-' + metric.groupName + '-' + company.companyName + '-' + data.period"
                                [id]="'metric-with-text-tooltip-' + metric.name + metric.groupName + company.companyName + data.period"
                                [iconNameAndStyling]="'copy-outline.svg;icon-size-1p25 black-9 clickable'"
                                (click)="copyToClipboard(data.rowValue)"
                              />
                            </div>
                          }
                          @case (MetricDataType.DOCUMENT) {
                            <div
                              *ngIf="data.rowValue && data.rowValue.includes('\n')"
                              [attr.data-qa]="'metric-with-document-tooltip-' + metric.name + '-' + metric.groupName + '-' + company.companyName + '-' + data.period"
                              [id]="'metric-with-document-tooltip-' + metric.name + metric.groupName + company.companyName + data.period"
                              class=" flex flex-grow items-center px-0.3125 gap-0.1562 w-full h-full main-8"
                              [ngClass]="'clickable active-cell-with-documents'"
                              (click)="showDocuments(data, metric, company.companyUUID)"
                              (mouseenter)="activateDocumentsToolTip( 'metric-with-document-tooltip-' + metric.name +
                               metric.groupName + company.companyName + data.period, data.rowValue)"
                              (mouseleave)="hideDocumentTooltip()">
                              <app-all-icons [iconNameAndStyling]="'documents-stack.svg;icon-size-0p9375'"/>
                              <span class="bold500 !text-[0.625rem]"> {{ data.rowValue | kpiDocumentsToCount}}</span>
                              <app-all-icons [iconNameAndStyling]="'expand-arrow-diagonal.svg;icon-size-0p9375;icon-expand-arrow'"/>
                            </div>
                          }
                        }
                      </div>
                    </td>
                  }
                  <td></td>
                </tr>
              }
            }
          }
        </tbody>
      </table>
    </div>
  </ng-container>
</div>

<app-kpi-cross-company-crud
  *ngIf="showCrudModal"
  [attr.data-qa]="'kpi-cross-company-crud'"
  (closeModal)="closeCrudModal($event)">
</app-kpi-cross-company-crud>

<app-kpi-cross-company-chart
  *ngIf="showChartModal"
  [chartMetric]="chartMetric"
  (closeEmitter)="closeChartModal()"
/>

@if (!!documentCrudWrapper.wrapper) {
  <app-kpi-modal-document-crud
    [isEditEnabled]="false"
    [isFromMetricSharedLinkPage]="false"
    [wrapper]="documentCrudWrapper.wrapper"
    (closeEmitter)="updateRowValueFromMetricDocumentAndClose($event)"/>
}

<app-tooltip *ngIf="tooltipDoc.show"
             [coordinates]="tooltipDoc.coordinates"
             [freezeOnHover]="false">
  <div *ngFor="let file of tooltipDoc.selectedFiles"
       class="!text-[0.625rem] font-medium break-words whitespace-normal max-w-[30rem]">
    {{file}}
  </div>
  <span class="!text-[0.5rem] opacity-90">Click to view and download</span>
</app-tooltip>
